import React from "react";

interface CircleShapeProps {
  a?: string | number;
  foldType?: string;
  foldDirection?: number;
  arrowColor?: string;
  textColor?: string;
}

const CircleShape: React.FC<CircleShapeProps> = ({
  a = "",
  foldType = "",
  foldDirection = 1,
  arrowColor = "#1E8F31",
  textColor = "#000"
}) => {
  return (
    <svg
      width="254"
      height="210"
      viewBox="-30 0 224 151"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Circle */}
      <path
        d="M189.489 75.5C189.489 114.712 157.701 146.5 118.489 146.5C79.2764 146.5 47.4886 114.712 47.4886 75.5C47.4886 36.2878 79.2764 4.5 118.489 4.5C157.701 4.5 189.489 36.2878 189.489 75.5Z"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M26.5 1L23.0359 7H29.9641L26.5 1ZM26.5 151L29.9641 145H23.0359L26.5 151ZM25.9 6.4L25.9 145.6H27.1L27.1 6.4H25.9Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text
        xmlSpace="preserve"
        textAnchor="end"
        fontFamily="Roboto"
        fontSize="12"
        y="79.69999"
        x="20.40026"
        fill={textColor}
      >
        A: {a}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <line
          x1="118.6"
          y1="1"
          x2="118.6"
          y2="150"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="143.6"
            y1="6"
            x2="143.6"
            y2="146"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="94.6"
            y1="6"
            x2="94.6"
            y2="146"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="118.6"
            y1="1"
            x2="118.6"
            y2="150"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="81.6"
            y1="16"
            x2="81.6"
            y2="136"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="155.6"
            y1="16"
            x2="155.6"
            y2="136"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line
          x1="191"
          y1="75.6"
          x2="46"
          y2="75.6"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="179"
            y1="50.6"
            x2="49"
            y2="50.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="179"
            y1="100.6"
            x2="49"
            y2="100.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="177"
            y1="43.6"
            x2="59"
            y2="43.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="191"
            y1="75.6"
            x2="47"
            y2="75.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="179"
            y1="106.6"
            x2="55"
            y2="106.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="180"
            y1="37.6"
            x2="58"
            y2="37.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="190"
            y1="64.6"
            x2="47"
            y2="64.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="189"
            y1="91.6"
            x2="50"
            y2="91.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="176"
            y1="118.6"
            x2="63"
            y2="118.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="177"
            y1="33.1"
            x2="68"
            y2="33.1"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="188"
            y1="55.6"
            x2="52"
            y2="55.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="190"
            y1="78.1"
            x2="50"
            y2="78.1"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="186"
            y1="100.6"
            x2="50"
            y2="100.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="173"
            y1="123.1"
            x2="68"
            y2="123.1"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}
    </svg>
  );
};

export default CircleShape;
